import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { useApi } from "@/lib/api";

const MeContext = createContext(null);

export function MeProvider({ children }) {
  const { isLoaded, isSignedIn } = useAuth();
  const api = useApi();
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/me");
      if (data.membership_prompt) sessionStorage.setItem("ahu_prompt", "1");
      setMe(data);
      return data;
    } catch {
      setMe(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, [api]);

  useEffect(() => {
    if (!isLoaded) return;
    if (isSignedIn) {
      localStorage.setItem("ahu_returning", "1");
      refresh();
    } else {
      setMe(null);
      setLoading(false);
    }
  }, [isLoaded, isSignedIn, refresh]);

  return <MeContext.Provider value={{ me, loading: !isLoaded || (isSignedIn && loading && !me), refresh }}>{children}</MeContext.Provider>;
}

export const useMe = () => useContext(MeContext);
